import React from "react";

function AboutUs() {
  return (
    <div className="page-container">
      <h2>🌙 About Us – Gulshan-e-Raza Foundation</h2>

      <p>
        गुलशन-ए-रज़ा फाउंडेशन एक सामाजिक एवं जनकल्याणकारी संगठन है, 
        जो शिक्षा, सामाजिक सुधार, कब्रिस्तान प्रबंधन, युवा मार्गदर्शन 
        और आर्थिक सहायता के क्षेत्र में कार्यरत है।
      </p>

      <p>
        हमारा उद्देश्य समाज में पारदर्शिता, सहयोग और सेवा की भावना 
        को बढ़ावा देना है ताकि ज़रूरतमंद लोगों तक सही सहायता 
        समय पर पहुंच सके।
      </p>

      <h3>🎯 Our Mission</h3>
      <p>
        शिक्षा को बढ़ावा देना, युवाओं को प्रतियोगी परीक्षाओं के लिए तैयार करना, 
        कब्रिस्तान की देखभाल करना और समाज में जागरूकता फैलाना।
      </p>

      <h3>🌟 Our Vision</h3>
      <p>
        एक शिक्षित, सशक्त और सुरक्षित समाज का निर्माण करना जहाँ 
        हर व्यक्ति को समान अवसर मिले।
      </p>

      <h3>💻 Digital Development</h3>
      <p>
        यह वेबसाइट आधुनिक तकनीक का उपयोग कर विकसित की गई है 
        ताकि समाज के लोग ऑनलाइन रजिस्ट्रेशन, भुगतान, 
        एडमिट कार्ड और अन्य सेवाओं का लाभ आसानी से ले सकें।
      </p>

      <p>
        <strong>Website Designed & Developed By:</strong><br />
        <a 
          href="https://www.aetmyweb.com" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          AR Expert Team – Web Development & Digital Solutions
        </a>
      </p>

      <p>
        हम वेबसाइट डेवलपमेंट, डैशबोर्ड सिस्टम, 
        ऑनलाइन रजिस्ट्रेशन पोर्टल, पेमेंट इंटीग्रेशन 
        और कस्टम सॉफ्टवेयर सॉल्यूशन प्रदान करते हैं।
      </p>
    </div>
  );
}

export default AboutUs;